import React from "react";
import {
  FaCoins,
  FaExchangeAlt,
  FaPlug,
  FaShieldAlt,
  FaUserAlt,
  FaChartBar,
  FaGlobe,
  FaQrcode,
} from "react-icons/fa";

function InstantConversion() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              {/* LEFT IMAGE */}
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/10.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-7 right-info pl-xs-15">
                <div className="container">
                  <div className="col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Key Features & Functionalities of Our Crypto Payment
                        Gateway
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="container">
                  <div className="services-style-four-items">
                    {/* 1 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCoins size={40} />
                      </div>
                      <h4>Multi-Currency Support</h4>
                      <p>
                        Accept a wide range of cryptocurrencies, including
                        Bitcoin, Ethereum, and stablecoins, enabling customers
                        to pay using their preferred digital assets.
                      </p>
                    </div>

                    {/* 2 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaExchangeAlt size={40} />
                      </div>
                      <h4>Instant Conversion to Fiat</h4>
                      <p>
                        Automatically convert crypto payments into fiat currency
                        in real-time, reducing volatility risks for merchants
                        and ensuring stable revenue.
                      </p>
                    </div>

                    {/* 3 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaPlug size={40} />
                      </div>
                      <h4>Seamless Integration</h4>
                      <p>
                        Easily integrate our payment gateway with popular
                        e-commerce platforms, POS systems, and custom websites,
                        allowing businesses to start accepting crypto payments
                        quickly.
                      </p>
                    </div>

                    {/* 4 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaShieldAlt size={40} />
                      </div>
                      <h4>Enhanced Security</h4>
                      <p>
                        Built with advanced security protocols, including
                        encryption and multi-signature wallets, to protect
                        transactions and safeguard sensitive customer
                        information.
                      </p>
                    </div>

                    {/* 5 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaUserAlt size={40} />
                      </div>
                      <h4>User-Friendly Interface</h4>
                      <p>
                        A simple and intuitive interface for both merchants and
                        customers, ensuring a smooth payment experience from
                        start to finish.
                      </p>
                    </div>

                    {/* 6 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaChartBar size={40} />
                      </div>
                      <h4>Comprehensive Analytics Dashboard</h4>
                      <p>
                        Provide merchants with valuable insights into
                        transaction history, customer behavior, and payment
                        trends to inform business decisions and strategies.
                      </p>
                    </div>

                    {/* 7 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaGlobe size={40} />
                      </div>
                      <h4>Global Reach</h4>
                      <p>
                        Enable businesses to tap into the growing global
                        cryptocurrency market, attracting new customers and
                        expanding their reach beyond traditional payment
                        methods.
                      </p>
                    </div>

                    {/* 8 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaQrcode size={40} />
                      </div>
                      <h4>Flexible Payment Options</h4>
                      <p>
                        Support various payment methods, including QR code
                        payments, online checkouts, and in-store transactions,
                        enhancing convenience for users.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InstantConversion;
